import { Page } from 'types/pages'

//* PUBLIC PAGES
export const PAGE_LOGIN: Page = { id: 'LOGIN', path: '/login', name: 'Login' }

export const PAGE_FORGOT_PASSWORD: Page = {
  id: 'FORGOT_PASSWORD',
  path: '/forgot-password',
  name: 'Forgot Password',
}

export const PAGE_RESET_PASSWORD: Page = {
  id: 'RESET_PASSWORD',
  path: '/reset',
  name: 'Reset Password',
}

export const PAGE_NOT_FOUND: Page = {
  id: 'NOT_FOUND',
  path: '/not-found',
  name: 'Page Not Found',
}

export const PAGE_SERVER_ERROR: Page = {
  id: 'SERVER_ERROR',
  path: '/server-error',
  name: 'Server Error',
}

//! PROTECTED PAGES
export const PAGE_DASHBOARD: Page = {
  id: 'DASHBOARD',
  path: '/',
  name: 'Dashboard',
}

export const PAGE_MASTER_DATA: Page = {
  id: 'MASTER_DATA',
  path: '/master-data',
  name: 'Master Data',
}

export const PAGE_ECOM_PRICING_DATA: Page = {
  id: 'ECOM_PRICING',
  path: '/ecom-pricing',
  name: 'Ecom Pricing',
}

export const PAGE_MASTER_DATA_UPDATE: Page = {
  id: 'MASTER_DATA_UPDATE',
  path: '/master-data/update',
  name: 'Update Master Data',
}

export const PAGE_BUNDLE_PRODUCT: Page = {
  id: 'BUNDLE_PRODUCT',
  path: '/bundle-product',
  name: 'Bundle Products',
}

export const PAGE_ADD_PRODUCT: Page = {
  id: 'ADD_PRODUCT',
  path: '/bundle-product/add',
  name: 'Add Bundle Product',
}

export const PAGE_INVENTORY: Page = {
  id: 'INVENTORY',
  path: '/inventory',
  name: 'Inventory',
}

export const PAGE_INVENTORY_UPDATE: Page = {
  id: 'INVENTORY_UPDATE',
  path: '/inventory/update',
  name: 'Inventory Update',
}

export const PAGE_PRICING: Page = {
  id: 'PRICING',
  path: '/pricing',
  name: 'Pricing',
}

export const PAGE_CLONE_INVENTORY_PRICE: Page = {
  id: 'CLONE_INVENTORY_PRICE',
  path: '/clone-inventory-price',
  name: 'Clone Inventory & Price',
}

export const PAGE_STORE_ORDERS: Page = {
  id: 'STORE_ORDERS',
  path: '/store-orders',
  name: 'Store Orders',
}

export const PAGE_ADMIN_ORDERS: Page = {
  id: 'ADMIN_ORDERS',
  path: '/orders',
  name: 'Admin Orders',
}

export const PAGE_POS_OPEN_ORDERS: Page = {
  id: 'ADMIN_OPEN_ORDERS',
  path: '/open-orders',
  name: 'POS Open Orders',
}

export const PAGE_ADMIN_ORDERS_DETAILS: Page = {
  id: PAGE_ADMIN_ORDERS.id + '_DETAILS',
  path: '/orders',
  name: 'Orders Details',
}

export const PAGE_POS_OPEN_ORDERS_DETAILS: Page = {
  id: PAGE_POS_OPEN_ORDERS.id + '_DETAILS',
  path: '/open-orders',
  name: 'POS Open Orders Details',
}

export const PAGE_PARTIAL_RMA: Page = {
  id: 'PAGE_RMA',
  path: '/orders/rma',
  name: 'Orders Details',
}

export const PAGE_RMA_DETAILS: Page = {
  id: 'PAGE_RMA',
  path: '/orders/rma',
  name: 'RMA Details',
}

export const PAGE_PRICING_UPDATE: Page = {
  id: 'PRICING_UPDATE',
  path: '/pricing/update',
  name: 'Pricing Update',
}

export const PAGE_SMART_OOS: Page = {
  id: 'SMART_OOS',
  path: '/smart-oos',
  name: 'Smart OOS',
}

export const PAGE_CRON_JOBS: Page = {
  id: 'CRON_JOBS',
  path: '/cron-jobs',
  name: 'Cron Jobs',
}

export const PAGE_FUNC_JOBS: Page = {
  id: 'FUNCTION_AND_JOBS',
  path: '/function-jobs',
  name: 'Function & Jobs',
}

export const PAGE_ERP_API_LOGS: Page = {
  id: 'ERP_API_LOGS',
  path: '/erp-api-logs',
  name: 'ERP API Logs',
}

export const PAGE_SAP_LOGS: Page = {
  id: 'SAP_LOGS',
  path: '/sap-logs',
  name: 'SAP Logs',
}

export const PAGE_ADMIN_AUDIT_LOGS: Page = {
  id: 'ADMIN_AUDIT_LOGS',
  path: '/admin-audit-logs',
  name: 'Admin Audit Logs',
}

export const PAGE_POS_API_LOGS: Page = {
  id: 'POS_API_LOGS',
  path: '/pos-api-logs',
  name: 'POS API Logs',
}

export const PAGE_FTP_CREATION_LOGS: Page = {
  id: 'FTP_CREATION_LOGS',
  path: '/ftp-creation-logs',
  name: 'FTP Creation Logs',
}

export const PAGE_AGGREGATOR_API_LOG: Page = {
  id: 'AGGREGATOR_API_LOG',
  path: '/aggregator-api-log',
  name: 'Aggregators API Logs',
}

export const PAGE_IMPORT_LOGS: Page = {
  id: 'IMPORT_LOGS',
  path: '/import-logs',
  name: 'Import Logs',
}

export const PAGE_EXPORT_LOGS: Page = {
  id: 'EXPORT_LOGS',
  path: '/export-logs',
  name: 'Export Logs',
}

export const PAGE_ORDERS_LOGS: Page = {
  id: 'ORDERS_LOGS',
  path: '/orders-logs',
  name: 'Orders Logs',
}

export const PAGE_RECONCILIATION_LOGS: Page = {
  id: 'RECONCILIATION_LOGS',
  path: '/reconciliation-logs',
  name: 'Reconciliation Logs',
}

export const PAGE_TALON_LOGS: Page = {
  id: 'TALON_LOGS',
  path: '/talon-logs',
  name: 'Talon Logs',
}

export const PAGE_CATALOGUE_ACTION_LOGS: Page = {
  id: 'CATALOGUE_ACTION_LOGS',
  path: '/catalogue-action-logs',
  name: 'Catalogue Action Logs',
}

export const PAGE_DELIVEROO_SYNC_LOGS: Page = {
  id: 'DELIVEROO_SYNC_LOGS',
  path: '/deliveroo-sync-logs',
  name: 'Deliveroo Sync Logs',
}

export const PAGE_TALABAT_LOGS: Page = {
  id: 'TALABAT_LOGS',
  path: '/talabat-logs',
  name: 'Talabat Logs',
}

export const PAGE_POWER_BI_SYNC_LOGS: Page = {
  id: 'POWER_BI_SYNC_LOGS',
  path: '/power-bi-sync-logs',
  name: 'Power BI Sync Logs',
}

export const PAGE_KDS_SYNC_LOGS: Page = {
  id: 'KDS_SYNC_LOGS',
  path: '/kds-sync-logs',
  name: 'KDS Sync Logs',
}

export const PAGE_LAST_MILE_LOGS: Page = {
  id: 'LAST_MILE_LOGS',
  path: '/last-mile-logs',
  name: 'Last Mile Logs',
}

export const PAGE_GENERIC_LOGS: Page = {
  id: 'GENERIC_LOGS',
  path: '/generic-logs',
  name: 'Generic Logs',
}

export const PAGE_CONFIG: Page = {
  id: 'CONFIGURATIONS',
  path: '/configurations',
  name: 'Configurations',
}

export const PAGE_TALABAT_CONFIG: Page = {
  id: 'TALABAT_CONFIGURATIONS',
  path: '/configurations/talabat',
  name: 'Talabat Configurations',
}

export const PAGE_APPROVER_MANAGER: Page = {
  id: 'APPROVER_MANAGER',
  path: '/configurations/approver-manager',
  name: 'Approver Manager',
}

export const PAGE_POWER_BI_CONFIG: Page = {
  id: 'POWER_BI_CONFIGURATIONS',
  path: '/configurations/power-bi',
  name: 'Power BI Configurations',
}

export const PAGE_KDS_CONFIG: Page = {
  id: 'KDS_CONFIGURATIONS',
  path: '/configurations/kds',
  name: 'KDS Configurations',
}

export const PAGE_ALERT_CONFIG: Page = {
  id: 'ALERT_CONFIGURATIONS',
  path: '/configurations/alert',
  name: 'Alert Configurations',
}

export const PAGE_MAGENTO_CONFIG: Page = {
  id: 'MAGENTO_CONFIGURATIONS',
  path: '/configurations/magento',
  name: 'Magento Configurations',
}

export const PAGE_INSTASHOP_LASTMILE_CONFIG: Page = {
  id: 'INSTASHOP_LASTMILE_CONFIGURATIONS',
  path: '/configurations/instashop-lastmile',
  name: 'Instashop Lastmile Configurations',
}

export const PAGE_POS_CONFIG: Page = {
  id: 'POS_CONFIGURATIONS',
  path: '/pos-configurations',
  name: 'Pos Configurations',
}

export const PAGE_USER_MGMT: Page = {
  id: 'USER_MANAGEMENT',
  path: '/user-management',
  name: 'User Management',
}

export const PAGE_ADD_USER: Page = {
  id: 'ADD_USER',
  path: '/user-management/add',
  name: 'Add User',
}

export const PAGE_UPDATE_USER: Page = {
  id: 'UPDATE_USER',
  path: '/user-management/update',
  name: 'Update User',
}
// -------------- Store Management --------------
export const PAGE_STORE_MGMT: Page = {
  id: 'STORE_MANAGEMENT',
  path: '/store-management',
  name: 'Store Management',
}

export const PAGE_ADD_STORE: Page = {
  id: 'ADD_STORE',
  path: '/store-management/add',
  name: 'Add Store',
}

export const PAGE_UPDATE_STORE: Page = {
  id: 'ADD_STORE',
  path: '/store-management/update',
  name: 'Update Store',
}

export const PAGE_AGGREGATOR_MANAGEMENT: Page = {
  id: 'AGGREGATORS_MANAGEMENT',
  path: '/aggregators-management',
  name: 'Aggregators Management',
}

export const PAGE_ADD_AGGREGATOR: Page = {
  id: 'ADD_AGGREGATORS',
  path: '/aggregators-management/add',
  name: 'Add Aggregator',
}

export const PAGE_UPDATE_AGGREGATOR: Page = {
  id: 'UPDATE_AGGREGATORS',
  path: '/aggregators-management/update',
  name: 'Update Aggregator',
}

export const PAGE_FTP_PROFILE: Page = {
  id: 'FTP_PROFILES',
  path: '/ftp-profiles',
  name: 'FTP Profiles',
}

export const PAGE_ADD_FTP_PROFILE: Page = {
  id: 'FTP_PROFILES',
  path: '/ftp-profiles/add',
  name: 'Add FTP Profile',
}

export const PAGE_UPDATE_FTP_PROFILE: Page = {
  id: 'FTP_PROFILES',
  path: '/ftp-profiles/update',
  name: 'Update FTP Profile',
}

export const PAGE_PRICE_LABEL = {
  id: 'PRICE_LABEL',
  path: '/price-label',
  name: 'Price Label',
}

export const PAGE_PRICE_LABEL_SYNC_HISTORY: Page = {
  id: 'PRICE_LABEL_SYNC_HISTORY',
  path: '/price-label-sync-history',
  name: 'Price Label Sync History',
}

export const PAGE_STOCK_OUT_REPORT: Page = {
  id: 'STOCK_OUT_REPORT',
  path: '/stock-out-report',
  name: 'Stock Out Report',
}

export const PAGE_PRICE_LABEL_REPORT: Page = {
  id: 'PRICE_LABEL_REPORT',
  path: '/price-label-report',
  name: 'Price Label Report',
}

export const PAGE_NEW_SAP_BARCODE: Page = {
  id: 'NEW_SAP_BARCODE',
  path: '/new-sap-barcode',
  name: 'New SAP Barcode',
}

export const PAGE_AREAS_MAPPING_MANAGEMENT: Page = {
  id: 'AREAS_MAPPING_MANAGEMENT',
  path: '/areas-management',
  name: 'Areas Management',
}

export const PAGE_POS_AREAS_MAPPING_MANAGEMENT: Page = {
  id: 'POS_AREAS_MAPPING_MANAGEMENT',
  path: '/pos-areas-management',
  name: 'POS Areas Management',
}

export const PAGE_PICKER_EMP_MAP: Page = {
  id: 'PICKER_EMP_MAP_MANAGEMENT',
  path: '/picker-emp-map-management',
  name: 'Picker Mapping Management',
}

export const COST_MANAGEMENT: Page = {
  id: 'COST_MANAGEMENT',
  path: '/cost-management',
  name: 'Cost Management',
}

export const PAGE_INVENTORY_STOCK_CHECKER: Page = {
  id: 'INVENTORY_STOCK_CHECKER',
  path: '/inventory-stock-checker',
  name: 'Inventory Stock Checker',
}

// -------------- Chain Management --------------
export const PAGE_CHAIN_MGMT: Page = {
  id: 'CHAIN_MANAGEMENT',
  path: '/chain-management',
  name: 'Chain Management',
}

export const PAGE_ADD_CHAIN: Page = {
  id: 'ADD_CHAIN',
  path: '/chain-management/add',
  name: 'Add Chain',
}

export const PAGE_UPDATE_CHAIN: Page = {
  id: 'UPDATE_CHAIN',
  path: '/chain-management/update',
  name: 'Update Chain',
}

// -------------- FOC order Management --------------

export const PAGE_FOC_ORDER_LIST: Page = {
  id: 'PAGE_FOC_ORDER_LIST',
  path: '/foc-orders',
  name: 'FOC orders',
}

export const PAGE_ADD_FOC_ORDER: Page = {
  id: 'ADD_FOC_ORDER',
  path: '/foc-orders/add',
  name: 'Add FOC Order',
}

// -------------- Pending ERP sync --------------

export const PAGE_PENDING_ERP_SYNC_ORDER: Page = {
  id: 'PENDING_ERP_SYNC_ORDER',
  path: '/pending-erp-sync-order',
  name: 'Pending ERP Sync Orders',
}

export const PAGE_PENDING_ERP_SYNC_RMA: Page = {
  id: 'PENDING_ERP_SYNC_RMA',
  path: '/pending-erp-sync-rma',
  name: 'Pending ERP Sync Rma',
}

export const PAGE_TIME_STAMP_RESET: Page = {
  id: 'TIMESTAMP_RESET',
  path: '/timestamp-reset',
  name: 'Timestamp Reset',
}

export const PAGE_PENDING_ERP_SYNC_RECON: Page = {
  id: 'PENDING_ERP_SYNC_RECON',
  path: '/pending-erp-sync-reconciliation',
  name: 'Pending ERP Sync Reconciliation',
}

export const PAGE_PURCHASE_TIMER: Page = {
  id: 'PURCHASE_TIMER_MANAGEMENT',
  path: '/purchase-timer',
  name: 'Purchase Timer',
}

export const PAGE_PURCHASE_TIMER_ADD: Page = {
  id: 'PURCHASE_TIMER_MANAGEMENT_ADD',
  path: '/purchase-timer/add',
  name: 'Add Purchase Timer',
}

export const PAGE_PURCHASE_TIMER_UPDATE: Page = {
  id: 'PURCHASE_TIMER_MANAGEMENT_UPDATE',
  path: '/purchase-timer/update',
  name: 'Update Purchase Timer',
}

//! FRESH INVENTORY MODULE PAGES
// Defined here so their ids match the backend's PAGE_ACCESS. A page gets added
// to PROTECTED_PAGES below once its screen is actually built - so far Fresh
// Reports (the one page the FRESH_REPORT role can be granted) and Fresh Category.
export const PAGE_FRESH_REPORTS: Page = {
  id: 'FRESH_REPORTS',
  path: '/fresh-reports',
  name: 'Fresh Reports',
}

export const PAGE_FRESH_CATEGORY: Page = {
  id: 'FRESH_CATEGORY',
  path: '/fresh-category',
  name: 'Fresh Category Management',
}

export const PAGE_FRESH_CATEGORY_ADD: Page = {
  id: 'FRESH_CATEGORY_ADD',
  path: '/fresh-category/add',
  name: 'Add Fresh Category',
}

export const PAGE_FRESH_CATEGORY_UPDATE: Page = {
  id: 'FRESH_CATEGORY_UPDATE',
  path: '/fresh-category/update',
  name: 'Update Fresh Category',
}

export const PAGE_FRESH_MANDATORY_BARCODE: Page = {
  id: 'FRESH_MANDATORY_BARCODE',
  path: '/fresh-mandatory-barcode',
  name: 'Fresh Mandatory Barcode',
}

export const PROTECTED_PAGES: Page[] = [
  PAGE_STORE_ORDERS,
  PAGE_ADMIN_ORDERS,
  PAGE_MASTER_DATA,
  PAGE_BUNDLE_PRODUCT,
  PAGE_INVENTORY,
  PAGE_PRICING,
  PAGE_SMART_OOS,
  PAGE_FUNC_JOBS,
  PAGE_ERP_API_LOGS,
  PAGE_SAP_LOGS,
  PAGE_ADMIN_AUDIT_LOGS,
  PAGE_POS_API_LOGS,
  PAGE_FTP_CREATION_LOGS,
  PAGE_AGGREGATOR_API_LOG,
  PAGE_IMPORT_LOGS,
  PAGE_EXPORT_LOGS,
  PAGE_ORDERS_LOGS,
  PAGE_DELIVEROO_SYNC_LOGS,
  PAGE_CATALOGUE_ACTION_LOGS,
  PAGE_RECONCILIATION_LOGS,
  PAGE_CONFIG,
  PAGE_POS_CONFIG,
  PAGE_USER_MGMT,
  PAGE_STORE_MGMT,
  PAGE_AGGREGATOR_MANAGEMENT,
  PAGE_AREAS_MAPPING_MANAGEMENT,
  PAGE_POS_AREAS_MAPPING_MANAGEMENT,
  PAGE_PICKER_EMP_MAP,
  COST_MANAGEMENT,
  PAGE_TALON_LOGS,
  PAGE_ECOM_PRICING_DATA,
  PAGE_INVENTORY_STOCK_CHECKER,
  PAGE_FOC_ORDER_LIST,
  PAGE_CHAIN_MGMT,
  PAGE_CLONE_INVENTORY_PRICE,
  PAGE_TALABAT_LOGS,
  PAGE_PRICE_LABEL,
  PAGE_PRICE_LABEL_SYNC_HISTORY,
  PAGE_PRICE_LABEL_REPORT,
  PAGE_NEW_SAP_BARCODE,
  PAGE_STOCK_OUT_REPORT,
  PAGE_POS_OPEN_ORDERS,
  PAGE_PENDING_ERP_SYNC_ORDER,
  PAGE_PENDING_ERP_SYNC_RMA,
  PAGE_PENDING_ERP_SYNC_RECON,
  PAGE_POWER_BI_SYNC_LOGS,
  PAGE_KDS_SYNC_LOGS,
  PAGE_LAST_MILE_LOGS,
  PAGE_GENERIC_LOGS,
  PAGE_CRON_JOBS,
  PAGE_TIME_STAMP_RESET,
  PAGE_PURCHASE_TIMER,
  PAGE_FTP_PROFILE,
  PAGE_FRESH_REPORTS,
  PAGE_FRESH_CATEGORY,
  PAGE_FRESH_MANDATORY_BARCODE,
]
